<template>
  <svg viewBox="0 0 313.76 284.51">
    <defs>
      <linearGradient id="mdklsa" x1="156.88" x2="156.88" y1="39.16" y2="3" gradientTransform="rotate(-90 156.88 21.08)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#fff" stop-opacity="0"/>
        <stop offset=".08" stop-color="#fff" stop-opacity=".03"/>
        <stop offset="1" stop-color="#fff" stop-opacity=".4"/>
      </linearGradient>
    </defs>
    <g>
      <rect width="311.76" height="282.51" x="1" y="1" fill="#ccc" rx="16" ry="16"/>
      <path fill="#eee" d="M296.76 2a15 15 0 0 1 15 15v250.51a15 15 0 0 1-15 15H17a15 15 0 0 1-15-15V17A15 15 0 0 1 17 2h279.76m0-2H17C7.63 0 0 7.63 0 17v250.51c0 9.37 7.63 17 17 17h279.76c9.37 0 17-7.63 17-17V17c0-9.37-7.63-17-17-17Z"/>
    </g>
    <path d="M17 2h279.76a15 15 0 0 1 15 15v23.16H2V17A15 15 0 0 1 17 2Z"/>
    <path fill="url(#mdklsa)" d="M152.8-132.8h22.16v307.76H152.8a14 14 0 0 1-14-14V-118.8a14 14 0 0 1 14-14Z" transform="rotate(90 156.88 21.08)"/>
    <text style="white-space:pre; text-transform: uppercase" x="18" y="26" fill="#A3C1F2" font-family="GT America" font-size="12px" font-weight="700" letter-spacing="0.8px">
      {{ recentAction }}
    </text>
    <g>
      <rect width="309.77" height="138.55" x="2" y="40.16" fill="#b0c8e9"/>
      <g>
        <g>
          <path fill="#c8d6eb" fill-rule="evenodd" d="M206.14 138.07a17.8 17.8 0 0 1-35.6 0V81.38a17.8 17.8 0 0 1 35.6 0v56.69Z"/>
          <g class="clickable" data-action="autocontour_down" data-label="Autocontour down">
            <circle cx="188.312" cy="138.365" ry="8.26" r="17.5" style="fill: #fff;" />
            <path fill="#54565a" fill-rule="evenodd" d="M184.63 134.29c-1.07 0-1.63 1.36-.9 2.09l6.73 7.79c.47.59 1.38.6 1.86 0l6.69-7.79c.77-.77.25-2.08-.86-2.09h-13.52Z"/>
            <path fill="#54565a" fill-rule="evenodd" d="M182.9 137.13a2.33 2.33 0 0 1-.25-2.85h-4.11c-1.07 0-1.62 1.36-.9 2.09l6.74 7.79c.47.59 1.38.6 1.85 0l1.37-1.6-4.7-5.44Z"/>
          </g>
          <g class="clickable" data-action="autocontour_up" data-label="Autocontour up">
            <circle cx="188.312" cy="81.21" ry="8.26" r="17.5" style="fill: #fff;" />
            <path fill="#54565a" fill-rule="evenodd" d="M198.14 85.15c1.08 0 1.63-1.36.9-2.09l-6.73-7.79a1.19 1.19 0 0 0-1.85 0l-6.69 7.79c-.77.77-.25 2.09.86 2.09h13.52Z"/>
            <path fill="#54565a" fill-rule="evenodd" d="M182.45 84.83a2.37 2.37 0 0 1 .48-2.52l4.66-5.43-1.38-1.6a1.19 1.19 0 0 0-1.85 0l-6.69 7.79c-.77.77-.24 2.09.86 2.09h4.09c-.06-.1-.12-.21-.17-.33Z"/>
          </g>
          <g>
            <g>
              <path fill="#fff" fill-rule="evenodd" d="m187.39 114.13 6.38-2.73c.31-.11.65-.17.94-.17l16.66.52 1-4.1c.34-1.34 2.13-1.14 2.13.28v5.32c0 .97-.79 1.76-1.78 1.76l-23.24.03c-.62 0-1.67-.11-2.41-.34-.33-.1 0-.4.32-.57Z"/>
              <path fill="#fff" fill-rule="evenodd" d="M172.35 111.02h10.37l6.08-4.72c.88-.4 1.94-.03 2.37.85.4.88-.14 1.68-.85 2.26l-6.24 4.87c-.79.55-2.13.73-3.01.73h-8.72c-1.11 0-2.02-.9-2.02-1.98s.91-2.02 2.02-2.02Z"/>
              <path fill="#fff" fill-rule="evenodd" d="M165.66 108.48a3.49 3.49 0 1 1 0 6.97 3.49 3.49 0 0 1 0-6.97Z"/>
            </g>
            <g>
              <path fill="#54565a" fill-rule="evenodd" d="m175.25 104.79 8.66 4.99 6.76-5.3c.8-.63 2.08-.51 2.68.31.6.82.37 1.95-.44 2.59l-6.81 5.32c-1.28 1.01-3.46.93-4.92.1l-7.91-4.51a2 2 0 0 1-.74-2.74 2 2 0 0 1 2.72-.77Z"/>
              <path fill="#54565a" fill-rule="evenodd" d="M169.02 98.81a3.49 3.49 0 1 1 0 6.97 3.49 3.49 0 0 1 0-6.97Z"/>
              <path fill="#54565a" fill-rule="evenodd" d="M195.78 106.83c1.37-1.09 2.97-1.32 4.85-.6l8.56 3.92 2.55-3.12c.86-1.09 2.45-.16 1.86 1.12l-2.25 4.94a1.84 1.84 0 0 1-2.38.88l-10.03-4.45-4.41 3.73c-2.22 1.71-4.9 2.05-7.57 1.45-.38-.08-.4-.52-.16-.7l8.98-7.17Z"/>
            </g>
          </g>
        </g>
        <g>
          <g>
            <path fill="#f29224" fill-rule="evenodd" d="M140.13 65.66a2.84 2.84 0 1 1 0 5.67h-4.54a2.84 2.84 0 0 1 0-5.67h4.54Z"/>
            <path fill="#54565a" fill-rule="evenodd" d="M142.48 79.06h-.25v-1.92c0-1.25-1-2.31-2.24-2.31a2.28 2.28 0 0 0-2.24 2.31v1.92h-.25a.49.49 0 0 0-.48.48v2.56a3.03 3.03 0 0 0 2.98 3.04 3.03 3.03 0 0 0 2.98-3.04v-2.56a.5.5 0 0 0-.48-.48Zm-2 2.69v1.15a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-1.15a.85.85 0 0 1 .5-1.54.85.85 0 0 1 .5 1.54Zm.79-2.69h-2.57v-1.95c0-.71.57-1.31 1.28-1.31.71 0 1.28.61 1.28 1.31v1.95Z"/>
          </g>
          <g>
            <path fill="#f29224" fill-rule="evenodd" d="M29.73 65.66c-1.57 0-2.83 1.27-2.83 2.83s1.27 2.84 2.83 2.84h4.54a2.84 2.84 0 0 0 0-5.67h-4.54Z"/>
            <path fill="#54565a" fill-rule="evenodd" d="M26.9 79.54v2.56a3.03 3.03 0 0 0 2.98 3.04 3.03 3.03 0 0 0 2.98-3.04v-2.56a.49.49 0 0 0-.48-.48h-.25v-1.92c0-1.25-.99-2.31-2.24-2.31a2.28 2.28 0 0 0-2.24 2.31v1.92h-.25a.49.49 0 0 0-.48.48Zm2.13 1.52a.85.85 0 1 1 1.34.69v1.15a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-1.15a.84.84 0 0 1-.35-.69Zm-.43-3.95c0-.71.57-1.31 1.28-1.31.71 0 1.28.61 1.28 1.31v1.95h-2.57v-1.95Z"/>
          </g>
          <path fill="#c8d6eb" fill-rule="evenodd" d="M54.69 63.57h60.47a17.8 17.8 0 0 1 17.8 17.8v56.7a17.8 17.8 0 0 1-17.8 17.8H54.69a17.8 17.8 0 0 1-17.8-17.8v-56.7c0-9.83 7.97-17.8 17.8-17.81Z"/>
          <g class="clickable" data-action="legs_up" data-label="Thighrest up">
            <circle cx="115.447" cy="81.309" ry="8.26" r="17.5" style="fill: #fff;" />
            <path fill="#54565a" fill-rule="evenodd" d="M108.41 85.15c-1.07 0-1.63-1.36-.9-2.09l6.73-7.79c.47-.59 1.38-.6 1.85 0l6.69 7.79c.77.77.25 2.09-.85 2.09h-13.52Z"/>
          </g>
          <g class="clickable" data-action="legs_down" data-label="Thighrest down">
            <circle cx="115.447" cy="138.365" ry="8.26" r="17.5" style="fill: #fff;" />
            <path fill="#54565a" fill-rule="evenodd" d="M121.92 134.29c1.07 0 1.62 1.36.9 2.09l-6.73 7.79c-.47.59-1.38.6-1.85 0l-6.69-7.79a1.22 1.22 0 0 1 .86-2.09h13.52Z"/>
          </g>
          <g class="clickable" data-action="backrest_down" data-label="Backrest down">
            <circle cx="54.63" cy="138.17" ry="8.26" r="17.5" style="fill: #fff;" />
            <path fill="#54565a" fill-rule="evenodd" d="M61.45 134.29c1.08 0 1.63 1.36.9 2.09l-6.73 7.8a1.2 1.2 0 0 1-1.86 0l-6.69-7.79a1.22 1.22 0 0 1 .86-2.09h13.52Z"/>
          </g>
          <g class="clickable" data-action="backrest_up" data-label="Backrest up">
            <circle cx="54.58" cy="81.309" ry="8.26" r="17.5" style="fill: #fff;" />
            <path fill="#54565a" fill-rule="evenodd" d="M47.94 85.16c-1.08 0-1.62-1.36-.9-2.09l6.73-7.79c.47-.59 1.38-.6 1.85 0l6.69 7.79c.77.76.24 2.08-.86 2.09H47.93Z"/>
          </g>
          <g>
            <g>
              <path fill="#fff" fill-rule="evenodd" d="m83 117.34 9.51-4.07c.47-.17.98-.25 1.4-.25l24.84.77 1.48-6.12c.5-2 3.18-1.7 3.18.42v7.93a2.65 2.65 0 0 1-2.66 2.63l-34.65.04c-.93 0-2.49-.17-3.59-.51-.49-.16.01-.6.48-.85Z"/>
              <path fill="#fff" fill-rule="evenodd" d="m60.59 112.7 15.46-.02 9.07-7.01a2.69 2.69 0 0 1 3.53 1.27c.59 1.32-.21 2.51-1.27 3.38l-9.29 7.24c-1.19.81-3.18 1.07-4.5 1.07h-.04l-12.95.04a3 3 0 0 1-3.01-2.95c0-1.65 1.35-3 3.01-3Z"/>
              <path fill="#fff" fill-rule="evenodd" d="M50.62 108.91a5.2 5.2 0 1 1 0 10.4 5.2 5.2 0 0 1 0-10.4Z"/>
            </g>
            <g>
              <path fill="#54565a" fill-rule="evenodd" d="m64.91 103.41 12.92 7.44 10.07-7.89c1.19-.94 3.1-.76 4 .47.89 1.23.55 2.91-.66 3.85l-10.15 7.94c-1.91 1.51-5.15 1.39-7.32.15l-11.8-6.72a2.97 2.97 0 0 1-1.1-4.09 2.96 2.96 0 0 1 4.04-1.15Z"/>
              <path fill="#54565a" fill-rule="evenodd" d="M55.62 94.49a5.2 5.2 0 1 1 .01 10.4 5.2 5.2 0 0 1-.01-10.4Z"/>
              <path fill="#54565a" fill-rule="evenodd" d="M95.51 106.45c2.04-1.63 4.42-1.96 7.23-.89l12.76 5.84 3.79-4.65c1.28-1.63 3.66-.24 2.77 1.68l-3.34 7.37a2.74 2.74 0 0 1-3.55 1.31l-14.95-6.63-6.58 5.56c-3.3 2.55-7.3 3.05-11.28 2.16-.56-.13-.6-.77-.24-1.05l13.4-10.69Z"/>
            </g>
          </g>
          <g>
            <path fill="#54565a" fill-rule="evenodd" d="M73.13 78.4c-.56 0-.84-.7-.47-1.08l3.49-4.04c.24-.3.71-.31.96 0l3.47 4.04c.4.39.12 1.08-.45 1.08h-7.01Z"/>
            <path fill="#54565a" fill-rule="evenodd" d="M73.13 85.16c-.56 0-.84-.7-.47-1.08l3.49-4.04a.61.61 0 0 1 .96 0l3.47 4.04c.4.4.12 1.08-.45 1.08h-7.01Z"/>
          </g>
        </g>
      </g>
      <g class="clickable" data-action="cpr" data-label="CPR">
        <path fill="#fff" fill-rule="evenodd" d="M278.41 138.29a17.8 17.8 0 1 1-35.6 0 17.8 17.8 0 0 1 35.6 0Z" class="fade-on-hover"/>
        <path fill="#e1251b" fill-rule="evenodd" d="M267.81 127.09a7.63 7.63 0 0 0-7.2 5.14 7.62 7.62 0 0 0-14.82 2.48c0 2.27.9 3.98 2.58 5.71 1.68 1.71 12.24 12.24 12.24 12.24s10.56-10.53 12.25-12.24c1.68-1.72 2.58-3.43 2.58-5.71a7.62 7.62 0 0 0-7.62-7.62Z"/>
        <g>
          <path fill="#fff" fill-rule="evenodd" d="M254.79 139.81c-.95 0-1.58-.81-1.58-2.03s.6-1.94 1.51-1.94c.58 0 .97.29 1.32.93l1.23-.65c-.64-1.08-1.47-1.58-2.6-1.58-1.76 0-3.03 1.35-3.03 3.23s1.28 3.35 3.08 3.35a2.8 2.8 0 0 0 2.65-1.68l-1.27-.6c-.35.7-.74.97-1.31.97Z"/>
          <path fill="#fff" fill-rule="evenodd" d="M268.26 138.47c.88-.33 1.28-.87 1.28-1.72a2 2 0 0 0-.51-1.39c-.38-.43-.96-.63-1.76-.63h-3.05v6.2h1.58v-2.19h.94l1.22 2.19h1.76l-1.46-2.46Zm-1.33-.91h-1.14v-1.65h1.2c.66 0 .97.26.97.8 0 .58-.33.85-1.03.85Z"/>
          <path fill="#fff" fill-rule="evenodd" d="M261.16 134.73h-3.1v6.2h1.58v-2.02h1.18c.78 0 1.39-.15 1.79-.44.53-.39.8-.96.8-1.69 0-.65-.21-1.19-.62-1.56-.37-.34-.91-.49-1.63-.49Zm-.48 3.07h-1.04v-1.88h1.13c.74 0 1.07.29 1.07.91 0 .68-.36.97-1.15.97Z"/>
        </g>
      </g>
    </g>
    <g>
      <g class="clickable" data-action="bed_height_up" data-label="Bed height up">
        <circle cx="63.899" cy="206.642" ry="8.26" r="17.5" style="fill: #fff;" />
        <path fill="#fff100" stroke="#54565a" stroke-miterlimit="10" stroke-width="1.5" d="M73.35 213.36c1.49 0 2.25-1.88 1.24-2.89l-9.31-10.79a1.65 1.65 0 0 0-2.57 0l-9.26 10.79a1.69 1.69 0 0 0 1.19 2.89h18.71Z"/>
      </g>
      <g class="clickable" data-action="bed_height_down" data-label="Bed height down">
        <circle cx="63.899" cy="252.409" ry="8.26" r="17.5" style="fill: #fff;" />
        <path fill="#fff100" stroke="#54565a" stroke-miterlimit="10" stroke-width="1.5" d="M54.65 247.42c-1.49 0-2.25 1.88-1.24 2.89l9.31 10.79c.65.82 1.91.82 2.57 0l9.26-10.79a1.69 1.69 0 0 0-1.19-2.89H54.65Z"/>
      </g>
      <g>
        <path fill="#54565a" fill-rule="evenodd" d="m68 229.58 16.27.37.87-3.74c.3-1.3 2.05-1.11 2.09.25v5.21c.03.94-.73 1.72-1.67 1.72l-24.98.02c-.36 0-.45-.45-.15-.61l6.69-3.06c.3-.11.6-.16.89-.16"/>
        <path fill="#54565a" fill-rule="evenodd" d="M57.08 232.86c-.77.39-1.66.3-2.49.3h-.05l-7.49.12a1.97 1.97 0 0 1-2-1.91 1.84 1.84 0 0 1 1.89-1.91h9.41l7.04-3.34a1.8 1.8 0 0 1 2.33.84c.41.86.08 1.83-.77 2.25l-7.86 3.66Z"/>
        <path fill="#54565a" fill-rule="evenodd" d="M37.08 230.39a3.37 3.37 0 1 0 6.74 0 3.37 3.37 0 0 0-6.74 0Z"/>
      </g>
    </g>
    <g>
      <g class="clickable" data-action="reverse_trendelenburg" data-label="Reverse Trendelenburg">
        <circle cx="155.523" cy="204.838" ry="8.26" r="17.5" style="fill: #fff;" />
        <path fill="#fff100" stroke="#54565a" stroke-miterlimit="10" stroke-width="1.5" d="M146.2 199.68c-1.49 0-2.25 1.88-1.24 2.89l9.31 10.79c.65.82 1.91.82 2.57 0l9.26-10.79a1.69 1.69 0 0 0-1.19-2.89H146.2Z"/>
      </g>
      <g>
        <path fill="#54565a" fill-rule="evenodd" d="M152.79 228.7c-.36 0-.65.06-.9.16l-14.73 6.37-2.29-3.03c-.77-1.09-2.34-.29-1.82.97l1.93 4.79c.38.84 1.38 1.28 2.22.9l22.98-9.25c.32-.1.22-.57-.09-.61l-7.3-.31Z"/>
        <path fill="#54565a" fill-rule="evenodd" d="m171.1 220.99-8.55 3.45-7.8-.39c-.93-.09-1.74.69-1.79 1.59-.06.97.69 1.74 1.62 1.83l8.63.44a5.2 5.2 0 0 0 2.46-.53l.04-.03 6.89-2.76a1.93 1.93 0 0 0 1.05-2.5 1.94 1.94 0 0 0-2.54-1.09Z"/>
        <path fill="#54565a" fill-rule="evenodd" d="M175.09 216.98a3.37 3.37 0 1 0 4.68 4.85 3.37 3.37 0 0 0-4.68-4.85Z"/>
      </g>
    </g>
    <g>
      <g class="clickable" data-action="trendelenburg" data-label="Trendelenburg">
        <circle cx="253.734" cy="204.838" ry="8.26" r="17.5" style="fill: #fff;" />
        <path fill="#fff100" stroke="#54565a" stroke-miterlimit="10" stroke-width="1.5" d="M263.22 199.68c1.49 0 2.25 1.88 1.24 2.89l-9.31 10.79c-.65.82-1.91.82-2.57 0l-9.26-10.79a1.69 1.69 0 0 1 1.19-2.89h18.71Z"/>
      </g>
      <g>
        <path fill="#54565a" fill-rule="evenodd" d="M248.63 225.06a2.2 2.2 0 0 0-.76-.51l-15.02-5.65.46-3.76c.2-1.32-1.48-1.83-1.98-.56l-1.93 4.79c-.31.87.1 1.88.97 2.19l22.95 9.31c.3.15.56-.25.36-.51l-5.04-5.3Z"/>
        <path fill="#54565a" fill-rule="evenodd" d="m267.15 232.24-8.55-3.46-5.34-5.7c-.61-.71-1.73-.71-2.39-.1a1.75 1.75 0 0 0-.1 2.44l5.91 6.31a5.2 5.2 0 0 0 2.14 1.32h.05l6.87 2.8c.97.41 2.09-.1 2.49-1.07a1.92 1.92 0 0 0-1.07-2.54Z"/>
        <path fill="#54565a" fill-rule="evenodd" d="M272.8 232.12a3.37 3.37 0 1 0 0 6.75 3.37 3.37 0 0 0 0-6.75Z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    recentAction: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
svg {
  width: 270px !important;
}

.clickable {
  circle {
    opacity: 0;
    transition: opacity 200ms ease;
  }
  &:hover circle {
    opacity: 0.4;
  }

  .fade-on-hover {
    transition: opacity 200ms ease;
  }
  &:hover .fade-on-hover {
    opacity: 0.6;
  }
}
</style>
